import { render, staticRenderFns } from "./CodingRuleEdit.vue?vue&type=template&id=1028f716&"
import script from "./CodingRuleEdit.vue?vue&type=script&lang=js&"
export * from "./CodingRuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports